import { render, staticRenderFns } from "./SaveReportWizardCoverholder.vue?vue&type=template&id=458221ad"
import script from "./SaveReportWizardCoverholder.vue?vue&type=script&lang=js"
export * from "./SaveReportWizardCoverholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports